// Lead Workspace tab config — same pattern as
// ../salesProjects/salesProjectTabs.js. Every tab is backed by real,
// already-authorized lead data (see docs audit): Overview/Requirements read
// straight off Nexceo::Lead; Activity/Site Visit/Documents/Property Match/
// Tasks reuse existing Nexceo:: controllers; Communications/Notes/Tags reuse
// Chatwoot's own conversation messages/labels APIs via lead.conversation_id.
export const LEAD_WORKSPACE_TABS = [
  { key: 'overview', label: 'Overview', icon: 'i-lucide-layout-dashboard' },
  { key: 'activity', label: 'Activity', icon: 'i-lucide-activity' },
  { key: 'requirements', label: 'Requirements', icon: 'i-lucide-clipboard-list' },
  { key: 'property-match', label: 'Property Match', icon: 'i-lucide-sparkles' },
  { key: 'site-visit', label: 'Site Visit', icon: 'i-lucide-calendar-check' },
  { key: 'notes', label: 'Notes', icon: 'i-lucide-sticky-note' },
  { key: 'tasks', label: 'Tasks', icon: 'i-lucide-list-checks' },
];

export function leadWorkspaceTabs({ id, accountId }) {
  return LEAD_WORKSPACE_TABS.map(tab => ({
    ...tab,
    to: {
      name: 'nexceo_lead_workspace',
      params: { id, accountId, tab: tab.key },
    },
  }));
}
